import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';

import { ComponentsModule } from '../../../components/components.module';

import { LearnLoadingComponent } from './learn-loading.component';

@NgModule({
  imports: [
    AngularCore,
    ComponentsModule,
    LearnLoadingComponent
  ],
  exports: [
    LearnLoadingComponent
  ]
})
export class LearnLoadingModule {
}

export {
  LearnLoadingComponent
};

